import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import COLORS from "../../../assets/Colors";
import { Paper } from "@material-ui/core";
import {
  TabStyle,
  StyledText,
  UpdatesWrapper,
  Label,
  LabelValueContainer,
  Value,
  GridContainer,
  Grid,
  Center,
  ProfileContainer,
  ProfilePic,
} from "./styles";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <TabStyle
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <StyledText style={{ height: "100%" }}>{children}</StyledText>
      )}
    </TabStyle>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
    overflow: "hidden",
    width: "100%",
    height: "100%",
    marginTop: "50px",
    "& .MuiTabs-indicator": {
      height: "0px !important",
    },
    "& .MuiTab-root": {
      padding: "6px 12px 6px 0px",
    },
    [theme.breakpoints.up(640)]: {
      borderRadius: "11px",
      border: `solid 1px ${COLORS.HEADER_BORDER} `,
      "& .MuiTabs-indicator": {
        height: "4px !important",
      },
      //   "& .MuiTab-root": {
      //     padding: "6px 12px",
      //   },
    },
  },

  appBar: {
    color: COLORS.COLOR_DARK,
    backgroundColor: COLORS.INPUT_BACKGROUND,
    boxShadow: "none",
    [theme.breakpoints.up(640)]: {
      backgroundColor: COLORS.PRIMARY_WHITE,
      borderBottom: `solid 1px ${COLORS.HEADER_BORDER} `,
    },
  },

  label: {
    display: "flex",
    fontFamily: "openSans-SemiBold, sans-serif",
    justifyContent: "center",
    alignItems: "center",
    width: 80,
    fontSize: "14px",
    [theme.breakpoints.up(400)]: {
      width: "auto",
      maxWidth: 230,
    },
  },

  "& .MuiTab-root": {
    padding: 0,
  },
}));

export default function SpeakersTab({ speakerSettings }) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  return (
    <Center className="mui-tabs">
      <UpdatesWrapper>
        <div className={classes.root}>
          <AppBar className={classes.appBar} position="static">
            <Tabs value={value} onChange={(_, newValue) => setValue(newValue)}>
              <Tab
                label={<div className={classes.label}>Speakers</div>}
                {...a11yProps(0)}
              />
            </Tabs>
          </AppBar>

          <TabPanel value={value} index={0}>
            <GridContainer>
              {speakerSettings?.length ? (
                speakerSettings?.map((item, index) => (
                  <Paper
                    style={{
                      padding: 16,
                      backgroundColor: "#E8F9FF",
                      // opacity: "0.6",
                    }}
                  >
                    <Grid>
                      <ProfileContainer>
                        <ProfilePic
                          alt="profile_img"
                          style={{
                            borderRadius:
                              item?.pictureTreatment === "circular"
                                ? "50%"
                                : "10%",
                          }}
                          src={
                            item.uploadPicture
                              ? item.uploadPicture
                              : require("../../../assets/images/userPlaceholder.svg")
                          }
                        />
                      </ProfileContainer>
                      <LabelValueContainer style={{ width: "auto" }}>
                        <Label>Name</Label>
                        <Value>
                          {item?.speakerName ? item?.speakerName : "N/A"}
                        </Value>
                      </LabelValueContainer>
                      <LabelValueContainer style={{ width: "auto" }}>
                        <Label>Company</Label>
                        <Value>
                          {item?.companyName ? item?.companyName : "N/A"}
                        </Value>
                      </LabelValueContainer>
                      <LabelValueContainer style={{ width: "auto" }}>
                        <Label>Designation</Label>
                        <Value>
                          {item?.designation ? item?.designation : "N/A"}
                        </Value>
                      </LabelValueContainer>
                      <LabelValueContainer style={{ width: "auto" }}>
                        <Label>Experience</Label>
                        <Value>
                          {item?.experience ? item?.experience : "N/A"}
                        </Value>
                      </LabelValueContainer>
                      <LabelValueContainer style={{ width: "auto" }}>
                        <Label>Date</Label>
                        <Value>
                          {item?.scheduleDate ? item?.scheduleDate : "N/A"}
                        </Value>
                      </LabelValueContainer>
                      <LabelValueContainer style={{ width: "auto" }}>
                        <Label>Time</Label>
                        <Value>
                          {item?.scheduleTime ? item?.scheduleTime : "N/A"}
                        </Value>
                      </LabelValueContainer>
                    </Grid>
                    <LabelValueContainer style={{ margin: "15px" }}>
                      <Label>About</Label>
                      <Value
                        dangerouslySetInnerHTML={{
                          __html: item?.aboutSpeaker
                            ? item?.aboutSpeaker
                            : "N/A",
                        }}
                      />
                    </LabelValueContainer>
                  </Paper>
                ))
              ) : (
                <Paper
                  style={{
                    padding: 16,
                    backgroundColor: "#E8F9FF",
                  }}
                >
                  <div
                    style={{
                      margin: "15px",
                    }}
                  >
                    No speakers found
                  </div>
                </Paper>
              )}
            </GridContainer>
          </TabPanel>
        </div>
      </UpdatesWrapper>
    </Center>
  );
}
